module.exports = {"451281100":"庆远镇","451281101":"三岔镇","451281102":"洛西镇","451281103":"怀远镇","451281104":"德胜镇","451281105":"石别镇","451281106":"北山镇","451281107":"刘三姐镇","451281108":"洛东镇","451281200":"祥贝乡","451281203":"屏南乡","451281207":"福龙瑶族乡","451281208":"北牙瑶族乡","451281210":"同德乡","451281211":"安马乡","451281213":"龙头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451281.json
// module id = 2298
// module chunks = 0